import * as React from 'react';
import { useMediaQuery } from 'react-responsive';
import classNames from 'classnames';
import BaseSectionWithAnalyticsContext from '../../common/BaseSection/BaseSectionWithAnalyticsContext.esm.js';
import '../../common/ContentfulImage/ContentfulImage.esm.js';
import 'tslib';
import '../../hooks/animation/animationContext.esm.js';
import '../../hooks/animation/classManipulation.esm.js';
import '../../types/animation.esm.js';
import '../../common/ContentfulImage/ImageContext.esm.js';
import { LargeImageContext } from '../../common/ContentfulImage/LargeImageContext.esm.js';
import { Grid } from '../../common/Grid/Grid.esm.js';
import { NvMarkdownInline, NvMarkdown } from '@invitae/ids-react';
import { BaseNucleobaseComponent } from '@invitae/nucleobase-core';
import { getPixelsBasedOnColumns } from '../../utils/misc.esm.js';
import styles from './BannerFactBlock.module.esm.js';

var BannerFactBlock = function (_a) {
    var _b = _a.fields, heading = _b.heading, internalName = _b.internalName, link = _b.link, body = _b.body, theme = _b.theme, headingSize = _b.headingSize, subheading = _b.subheading, image = _b.image, imageVerticalAlignment = _b.imageVerticalAlignment, _c = _b.contentPosition, contentPosition = _c === void 0 ? 'left' : _c, _d = _b.mobileTextAlignment, mobileTextAlignment = _d === void 0 ? 'left' : _d, decorativeShape = _b.decorativeShape, imagePositionOnMobile = _b.imagePositionOnMobile, id = _a.id, dataCy = _a["data-cy"];
    var contentClass = "content-".concat(contentPosition);
    var imageClass = "image-".concat(imageVerticalAlignment);
    var mobileTextPositionClass = "mobile-text-".concat(mobileTextAlignment);
    var headingSizeClass = {
        large: 'heading-large',
        regular: 'heading-regular',
    }[headingSize];
    var className = classNames(styles.root, styles[theme], styles[imageClass]);
    var darkThemes = ['cobalt'];
    var isWhiteButton = darkThemes.includes(theme);
    var isDesktop = useMediaQuery({ query: '(min-width: 720px)' });
    var imageMobilePosition = "image-mobile-position-".concat(imagePositionOnMobile);
    var contentMobilePosition = "content-mobile-position-".concat(imagePositionOnMobile);
    var shouldRenderImage = (imagePositionOnMobile !== 'hidden' && !isDesktop) || isDesktop;
    return (React.createElement(BaseSectionWithAnalyticsContext, { className: classNames(className, styles.root), "data-cy": dataCy, id: id, sectionName: internalName },
        decorativeShape && React.createElement(BaseNucleobaseComponent, { source: decorativeShape }),
        React.createElement(Grid, { className: styles.grid },
            shouldRenderImage && (React.createElement(LargeImageContext, null,
                React.createElement(BaseNucleobaseComponent, { classes: { picture: classNames(styles.image, styles[imageClass], styles[imageMobilePosition]) }, maxImageWidth: getPixelsBasedOnColumns(4), role: "presentation", source: image }))),
            React.createElement("div", { className: classNames(styles.content, styles[contentClass], styles[mobileTextPositionClass], styles[contentMobilePosition]) },
                React.createElement(NvMarkdownInline, { className: classNames(styles.heading, styles[headingSizeClass]), elementWrapper: "h2" }, heading),
                subheading && (React.createElement(NvMarkdownInline, { className: styles.subheading, elementWrapper: "h3" }, subheading)),
                body && (React.createElement(NvMarkdown, { className: styles.body, "data-testid": "fact-banner-body" }, body)),
                link && (React.createElement("div", { className: styles.actions },
                    React.createElement(BaseNucleobaseComponent, { classes: { link: classNames('nv-button', styles.button, { 'nv-button-white': isWhiteButton }) }, source: link })))))));
};

export { BannerFactBlock as default };
//# sourceMappingURL=BannerFactBlock.esm.js.map
